import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-40 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-6 lg:px-16">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
              Privacy Policy
            </h1>
            <p className="text-lg text-gray-600">
              Last updated: December 14, 2024
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-16">
          <div className="max-w-4xl space-y-12">
            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">1. Introduction</h2>
              <p className="text-gray-700 leading-relaxed">
                ETAN LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website etanllc.com or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We may collect information about you in a variety of ways. The information we may collect includes:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span><strong>Personal Data:</strong> Name, email address, company name, and other contact information you provide when contacting us.</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span><strong>Communication Data:</strong> Information contained in or relating to any communication that you send to us or through our website.</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span><strong>Usage Data:</strong> Information about how you use our website and services.</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">3. Use of Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use the information we collect in the following ways:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>To respond to your inquiries and provide customer service</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>To send you information about our services</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>To improve our website and services</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>To comply with legal obligations</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">4. Disclosure of Your Information</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted third parties who assist us in operating our website, conducting our business, or servicing you, provided that those parties agree to keep this information confidential.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">5. Data Security</h2>
              <p className="text-gray-700 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">6. Your Rights</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Request access to your personal data</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Request correction of your personal data</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Request deletion of your personal data</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Object to processing of your personal data</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">7. International Data Transfers</h2>
              <p className="text-gray-700 leading-relaxed">
                ETAN LLC is based in Dubai, United Arab Emirates. Information we collect may be transferred to, stored, and processed in the UAE or other countries where we operate. We ensure appropriate safeguards are in place for such transfers.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">8. Changes to This Privacy Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">9. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded">
                <p className="text-gray-700">
                  <strong>ETAN LLC</strong><br />
                  Dubai, United Arab Emirates<br />
                  Email: info@etanllc.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;